import React from 'react';
import { observer } from 'mobx-react';
import RemoveDeviceComponent from './Remove-device.component';
import useRemoveDevice from './useRemoveDevice';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, devices, lang, handlers } = useRemoveDevice(onClose);

    return (
        <>
            <RemoveDeviceComponent
                lang={lang.lang}
                loading={subusers.removeDeviceLoading || subusers.loading}
                serverError={subusers.serverError}
                selectedSubuser={subusers.selectedSubuser}
                selectedDevice={subusers.selectedDevice}
                devices={devices.deviceList}
                onConfirmClick={handlers.handleConfirmClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onCancelClick={onClose}
            />
        </>
    );
};

const RemoveDeviceContainer = observer(Container);

export default RemoveDeviceContainer;
